<script setup lang="ts">
  import { MpCard, MpText } from '@borg/ui';

  const job = jobRepository.use();
</script>

<template>
  <MpCard
    v-if="job"
    border
    class="card-nav"
  >
    <div class="card-nav__body">
      <MpText
        as="h4"
        no-margin
      >
        {{ job.title }}
      </MpText>
      <MpText
        as="h6"
        regular
        no-margin
      >
        {{
          job.organization === 'incognito' ? $t('ORGANIZATION_INCOGNITO') : job.organization.name
        }}
      </MpText>
    </div>
  </MpCard>
</template>

<style scoped lang="scss">
  .card-nav {
    display: flex;
    align-items: center;
    gap: var(--mp-space-50);
    background-color: var(--mp-color-grey-100);

    @include dark-mode {
      background-color: var(--mp-color-surface-10);
    }

    &__body {
      display: flex;
      flex-direction: column;
    }
  }
</style>
